const swagger = {
    invalid_zod_type: 'Kiểu Zod không hợp lệ. Vui lòng kiểm tra lại cấu hình route guard.',
    not_supported_zod_type_for_params: 'Kiểu Zod không được hỗ trợ cho tham số này. Vui lòng kiểm tra lại cấu hình route guard.',
};
export default Object.freeze(swagger);
